import { NavbarPrimary as NavbarContainer } from '@unimed-fesp/components';
import React, { useEffect, useState } from 'react';
import { MdInput } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';

import { Creators as AuthActions } from '../../../store/ducks/auth';
import { Creators as UsuarioActions } from '../../../store/ducks/usuario';

import { TipoPerfilUsuarioEnum } from '../../../enums';
import { legacyRoutes } from '../../../routes/legacyRoutes';
import { isAdmin, isOldAdmin } from '../../../utils/userRole';

// #region Componentes
import DropChangeParametrizacao from '../DropChangeParametrizacao';
import ModalLogout from '../ModalLogout';
// #endregion

import { NavbarItemContainer, NavbarItemsContainer } from './styles';

function NavbarPrimary() {
  const dispatch = useDispatch();
  const { usuario, accessToken } = useSelector((state) => state.auth);
  const { getContratantesUsuario } = useSelector((state) => state.usuario);

  let contratantes = [];
  const nomeComplemento =
    getContratantesUsuario?.response?.nomeComplemento || '';

  if (getContratantesUsuario?.response?.contranteParametrizada) {
    contratantes = getContratantesUsuario.response.contranteParametrizada.map(
      (contratante) => ({
        nome: `${contratante.codigoContratante} - ${contratante.nomeContratante}`,
      })
    );
  }

  const [open, setOpen] = useState(false);

  const selectedContratante =
    usuario.role === 'Adm'
      ? ''
      : `${usuario.codigoContratante} - ${usuario.nomeEmpresa}`;

  function handleLogOut() {
    setOpen(!open);
  }

  function handleSignOut() {
    dispatch(AuthActions.signOutLegadoRequest());
  }

  function handleSelectedContratante(contratante) {
    let tempContratante = contratante;
    if (contratante === TipoPerfilUsuarioEnum.returnNameFormattedForName.Adm)
      tempContratante = `0 - ${TipoPerfilUsuarioEnum.returnNameFormattedForName.Adm}`;

    const [id, ...rest] = tempContratante?.split('-');
    dispatch(
      AuthActions.getChangeTokenRequest({
        id,
      })
    );
  }

  useEffect(() => {
    if (usuario.idUsuarioLogado !== 0 && !isAdmin())
      dispatch(
        UsuarioActions.getContratantesUsuarioRequest(usuario.idUsuarioLogado)
      );
  }, [dispatch, usuario.idUsuarioLogado, usuario.role]);

  return (
    <>
      <NavbarContainer nomeSistema="MovCad" urlHome={legacyRoutes.Home.url}>
        <NavbarItemsContainer justifyEnd alignCenter>
          {!isOldAdmin(accessToken) && (
            <DropChangeParametrizacao
              contratantes={contratantes}
              headerText={selectedContratante}
              onClick={handleSelectedContratante}
              nomeComplemento={nomeComplemento}
            />
          )}
          {usuario.nome && (
            <NavbarItemContainer marginRight="92px" marginLeft="43px">
              {usuario.nome}
              <MdInput onClick={handleLogOut} size="20" />
            </NavbarItemContainer>
          )}
        </NavbarItemsContainer>
      </NavbarContainer>
      <ModalLogout
        logOut={handleSignOut}
        onClick={handleLogOut}
        isOpen={open}
      />
    </>
  );
}

export default NavbarPrimary;
